import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const painPoints = [<>
    Todo lo que horneas queda <strong data-id="element-172">seco y sin sabor</strong>. 😩
  </>, <>
    El <strong data-id="element-173">pan de cartón del súper</strong> te arruina el bolsillo. 💸
  </>, <>
    Pruebas <strong data-id="element-174">receta tras receta</strong> y nada funciona. 😤
  </>, <>
    No sabes <strong data-id="element-175">qué comer</strong> sin terminar sintiéndote peor. 😞
  </>];
export function PainPointsSection() {
  return <section className="py-5 md:py-10 px-4 bg-brand-creamAlt" data-id="element-176">
      <div className="max-w-3xl mx-auto" data-id="element-177">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-terracotta text-white text-center py-5 px-6 rounded-xl mb-8 shadow-lg" data-id="element-178">
          <h2 className="text-lg md:text-3xl font-heading font-bold uppercase tracking-wide" data-id="element-179">
            ESTAS RECETAS SON PARA TI SI...
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-180">
          {painPoints.map((content, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.15
        }} className="flex items-center gap-4 bg-white p-5 md:p-6 rounded-xl shadow-sm border-l-[6px] border-brand-terracotta" data-id="element-181">
              <XCircle className="w-7 h-7 text-white fill-brand-red flex-shrink-0" data-id="element-182" />
              <p className="text-lg text-brand-brownLight leading-relaxed [&_strong]:text-brand-brown" data-id="element-183">
                {content}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}